import React from "react";
import styles from "./progress.module.css";


const Stages = ({children, active, extraElement=null, ...props}) => {
    const childs = React.Children.toArray(children)
    return (
        <div className={styles.Stages}>
            {React.cloneElement(childs[active -1],{ ...props})}
            {extraElement}
        </div>
        
    )
}

export default Stages;